/* eslint-disable prefer-rest-params */
const debounce = (func, delay) => {
  let timeout;
  return function () {
    const obj = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(obj, args), delay || 1000);
  };
};
export default debounce;
